import React from 'react';
import Content from '../Content';
import { Wrapper } from './styles';
export var Layout = function Layout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      constrainWidth = _ref.constrainWidth,
      disableGutter = _ref.disableGutter,
      left = _ref.left,
      right = _ref.right;
  return /*#__PURE__*/React.createElement(Wrapper, {
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(Content, {
    constrainWidth: constrainWidth,
    disableGutter: disableGutter,
    left: left,
    right: right
  }, children));
};
export default Layout;